import { FONT_SETTINGS } from "../fonts";
import FoundryLink from "../components/FoundryLink";
import LogoBlack from "../public/img/logo_black.svg";
import NewsletterSignup from "../components/NewsletterSignup";
import Routes from "../routes";

interface FooterProps {
  scrollToTopSelector?: any;
}

export default function Footer(props: FooterProps) {
  const socialIconsSize = "18px";

  return (
    <footer
      className={`container-full w-full flex flex-col z-20 pt-16 pb-36 transition-colors duration-1000 gap-4 bg-neutral-900`}
    >
      <div className="flex items-center gap-3 lg:gap-4">
        <FoundryLink href="/">
          <div className="logo logo--lg">
            <LogoBlack />
          </div>
        </FoundryLink>
        <span className="t1 color-blue-hover">
          <FoundryLink href="/" style={{ fontFamily: "ST Nebulith Display" }}>
            Space Type
          </FoundryLink>
        </span>
      </div>
      <div className="flex flex-col lg:flex-row justify-between gap-12 sm:gap-8">
        <div className="flex-item-3-5 flex-item-sm-1">
          <p className="max-w-[400px] 2xl:max-w-[500px]">
            Stay in touch: new workshops, classes, typefaces, and updates to our
            online resources.
          </p>
          <FoundryLink href="https://spacetypeco.substack.com" className="inline-block w-fit py-4 rounded-md px-8 border-2 border-gold bg-gold-hover color-gold color-secondary-hover transition"
          >Join the Newsletter →</FoundryLink>
        </div>
        <div className="sm:flex gap-12 sm:gap-0 sm:flex-row grid grid-cols-2">
          <div
            className={`flex flex-col ${process.env.NEXT_PUBLIC_ENABLE_FOUNDRY ? "pr-12" : "pr-24"
              }`}
          >
            <h3 className="pb-1 sm:pb-4">Contact</h3>
            <span>
              <a
                href="mailto:hello@spacetypeco.com"
                className="color-blue-hover"
              >
                hello@spacetypeco.com
              </a>
            </span>
            <FoundryLink href={Routes.faq} className="color-blue-hover">
              Shipping and Returns
            </FoundryLink>
            <span>
              <a
                href="https://instagram.com/spacetypeco"
                className="color-blue-hover"
              >
                Instagram
              </a>
            </span>
          </div>
          {process.env.NEXT_PUBLIC_ENABLE_FOUNDRY && (
            <>
              <div className="flex flex-col pr-12">
                <h3 className="pb-1 sm:pb-4">Typefaces</h3>
                {Object.values(FONT_SETTINGS).map((family) => {
                  return (
                    <span key={family.name}>
                      <FoundryLink
                        href={Routes.fonts.family(family.name.toLowerCase())}
                      >
                        {family.name}
                      </FoundryLink>
                    </span>
                  );
                })}
              </div>
              <div className="flex flex-col pr-12">
                <h3 className="pb-1 sm:pb-4">Information</h3>
                <span>FAQ</span>
                <span>Licensing</span>
                <span>Trial Fonts</span>
                <span>Trial Licensing</span>
              </div>
            </>
          )}
          <div className="flex flex-col pr-12">
            <h3 className="pb-1 sm:pb-4">Space Type</h3>
            <FoundryLink
              href={Routes.account.index}
              className="color-blue-hover"
            >
              Manage Account
            </FoundryLink>
            <FoundryLink href={Routes.shop.index} className="color-blue-hover">
              Shop Products
            </FoundryLink>
            <FoundryLink href={Routes.cart.index} className="color-blue-hover">
              View Cart
            </FoundryLink>
            <FoundryLink
              href={Routes.print}
              className="color-blue-hover"
            >
              Print With Us
            </FoundryLink>
            <FoundryLink
              href={Routes.about}
              className="color-blue-hover"
              target="_blank"
            >
              About
            </FoundryLink>
          </div>
        </div>
      </div>
    </footer >
  );
}
